import { createFeatureSelector, createSelector } from "@ngrx/store";
import { StudentsState, studentFeatureKey } from "./students.reducers";
import * as fromReducer from "./students.reducers";
import { groupStudentsByFirstLetter } from "src/app/utils/GroupStudents";

const selectFeature = createFeatureSelector<StudentsState>(
    studentFeatureKey,
);

export const {
    selectAll: selectAllStudents,
    selectEntities: selectStudentEntities,
} = fromReducer.adapter.getSelectors(selectFeature as any);

export const selectStudentById = (id: number) => (state: any) => {
    return selectStudentEntities(state)[id];
}

export const selectArchivedStudents = createSelector(
    selectFeature,
    selectStudentEntities,
    (state, entities) => {
        return entities ? Object.values(entities).filter(student => student.is_archived) : [];
    }
)

export const selectActiveStudents = createSelector(
    selectFeature,
    selectStudentEntities,
    (state, entities) => {
        return entities ? Object.values(entities).filter(student => !student?.is_archived) : [];
    }
)

export const selectActiveStudentsSections = createSelector(
    selectActiveStudents,
    (students) => {
        return groupStudentsByFirstLetter(students);
    }
)

export const selectStudentCount = createSelector(
    selectFeature,
    selectStudentEntities,
    (state, entities) => {
        return entities ? Object.values(entities).length : 0;
    }
)

export const selectIsLoaded = (state: any) => {
    return state[studentFeatureKey].isLoaded;
}

export const selectHasLoadedAttachment = (state: any) => {
    return state[studentFeatureKey].hasLoadedAttachment;
}

export const selectSelectedStudent = createSelector(
    selectFeature,
    selectStudentEntities,
    (state, entities) => {
      const selectedStudentId = state.selectedStudent;
      return selectedStudentId ? entities[selectedStudentId] : null;
    }
)
